<div class="auth__header">
    <h1 class="auth__title">Cambiar Contraseña</h1>
</div>
<form class="auth__body" [formGroup]="form" (ngSubmit)="onSubmit()">
  <mat-form-field appearance="fill">
    <mat-label>Actual Contraseña</mat-label>
    <input matInput [type]="hideActualPassword ? 'password' : 'text'" formControlName="actualClave"/>
    <button type="button" mat-icon-button matSuffix (click)="hideActualPassword = !hideActualPassword" matTooltip="Mostrar contraseña">
      <mat-icon>{{hideActualPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
    </button>
    <mat-error *ngIf="actualClaveField.hasError('required')">La contraseña es obligatoria</mat-error>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Contraseña</mat-label>
    <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="nuevaClave"/>
    <button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword" matTooltip="Mostrar contraseña">
      <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
    </button>
    <mat-error *ngIf="nuevaClaveField.hasError('required')">La contraseña es obligatoria</mat-error>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Confirmar Contraseña</mat-label>
    <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="nuevaClaveConfirm"/>
    <button type="button" mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" matTooltip="Mostrar contraseña">
      <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
    </button>
    <mat-error *ngIf="nuevaClaveConfirmField.hasError('required')">Este campo es obligatorio</mat-error>
  </mat-form-field>

  <div class="auth__actions">
    <button mat-raised-button color="primary" type="submit">Cambiar Contraseña</button>
    <button mat-stroked-button mat-dialog-close color="primary" type="button">Volver</button>
  </div>
</form>